/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtoupdateimageorder4Inputs */

const en_failedtoupdateimageorder4 = /** @type {(inputs: Failedtoupdateimageorder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update image order`)
};

const de_failedtoupdateimageorder4 = /** @type {(inputs: Failedtoupdateimageorder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildreihenfolge konnte nicht aktualisiert werden`)
};

/**
* | output |
* | --- |
* | "Failed to update image order" |
*
* @param {Failedtoupdateimageorder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtoupdateimageorder4 = /** @type {((inputs?: Failedtoupdateimageorder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtoupdateimageorder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtoupdateimageorder4(inputs)
	return de_failedtoupdateimageorder4(inputs)
});
export { failedtoupdateimageorder4 as "failedToUpdateImageOrder" }